import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBell = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M7 18.9999H13",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M3.26904 7.74994C3.2678 6.86045 3.44262 5.97951 3.78343 5.1579C4.12424 4.33628 4.6243 3.59025 5.25477 2.9628C5.88525 2.33535 6.63368 1.83889 7.45693 1.50204C8.28017 1.16519 9.16194 0.994607 10.0514 1.00013C13.763 1.02772 16.7317 4.11275 16.7317 7.83468V8.49994C16.7317 11.8577 17.4342 13.8061 18.0529 14.871C18.1196 14.9848 18.1551 15.1142 18.1558 15.246C18.1565 15.3779 18.1224 15.5076 18.0569 15.6221C17.9915 15.7366 17.8971 15.8318 17.7831 15.8982C17.6691 15.9645 17.5397 15.9996 17.4078 15.9999H2.59222C2.46034 15.9996 2.33087 15.9645 2.21689 15.8981C2.1029 15.8318 2.00844 15.7366 1.94301 15.622C1.87759 15.5075 1.84352 15.3778 1.84425 15.2459C1.84498 15.114 1.88048 14.9846 1.94716 14.8709C2.56622 13.8059 3.26904 11.8575 3.26904 8.49994L3.26904 7.74994Z",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgBell;
